import { Popup } from './Popup.js';
// CLASS PopupWithForm:
export class PopupWithForm extends Popup {
    constructor({ popupSelector, defaultText, submitCallbackFunction }) {
        super(popupSelector);
        this._popupForm = this._popup.querySelector('.popup__form');
        this._defaultText = defaultText;
        this._inputList = this._popup.querySelectorAll('.popup__input');
        this._submitCallbackFunction = submitCallbackFunction;
        this._buttonSubmit = this._popup.querySelector('.popup__button');
    }

    isLoadingText(isLoading) {
        if(isLoading === true) {
            this._buttonSubmit.textContent = 'Сохранение...';
            this._buttonSubmit.disabled = true;

        } else {
            this._buttonSubmit.textContent = this._defaultText;
            this._buttonSubmit.disabled = false;

        }
    }

    _getInputValues() {
        const inputValues = {};
        this._inputList.forEach(input => {
            inputValues[input.getAttribute('name')] = input.value;
        });
        return inputValues;
    };

    setEventListeners() {
        super.setEventListeners();
        this._popupForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this._submitCallbackFunction(this._getInputValues());
        });
    }

    close() {
        super.close();
        this._popupForm.reset();
    }
}